export default class WaitingPeriodAbstractServices {
  static getWaitingPeriodsReferenceData() {
    logger.error('Support:: getWaitingPeriodsReferenceData() not implemented');
  }

  static getWaitingPeriods() {
    logger.error('Support: getWaitingPeriods() not implemented');
  }
}
